import { render, staticRenderFns } from "./select-person.vue?vue&type=template&id=627a05f6"
import script from "./select-person.vue?vue&type=script&lang=js"
export * from "./select-person.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports